<template>
  <div>
    <base-period-select
      v-model="searchDates"
      class="justify-start ml-2"
      :bootstrap="BOOTSTRAP"
    />
    <base-loading v-if="!ready" />
    <v-container
      v-else
      fluid
      style="margin-bottom: 60px;"
    >
      <v-row
        class="pt-0 pb-0 py-0"
      >
        <v-col
          cols="12"
          lg="12"
          xl="12"
          sm="12"
          class="graficoPieTec"
        >
          <material-chart-card
            :data="dashboard.grafico_atendimento_setor || {}"
            :options="optionsSet"
            type="Pie"
            color="primary"
            title="Atendimentos por Setor (R$)"
            icon="mdi-chart-donut"
            sub-icon-left="mdi-clock-outline"
            sub-icon-coloer-left="info"
            :sub-text-left="labelGrafico"
            elevation="3"
          />
        </v-col>
      </v-row>
      <v-row
        class="pt-0 pb-0 py-0"
      >
        <v-col
          cols="12"
          sm="12"
          lg="12"
          xl="12"
          class="graficoLine"
        >
          <!-- class="legendasPedido grafico-barra" -->
          <material-chart-card
            :data="dashboard.grafico_atendimento_periodo || []"
            :options="optionsAtendimentoPorTecnico()"
            type="Line"
            color="primary"
            title="Atendimentos no Período"
            icon="mdi-chart-line"
            sub-icon-left="mdi-clock-outline"
            sub-icon-color-left="info"
            :sub-text-left="labelGrafico"
            elevation="3"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          lg="12"
          xl="12"
        >
          <material-card
            color="primary"
            title="Positivação de clientes"
            icon="mdi-chart-donut"
            elevation="3"
            style="min-width: '100%'; min-height: 435px;"
          >
            <v-row
              class="pt-11"
              justify="center"
              style="overflow-y: hidden;"
            >
              <vue-speedometer
                :max-segment-labels="5"
                :segments="5"
                :min-value="0"
                value-format="d"
                :max-value="dashboard.grafico_produtor.limite || 0"
                :value="dashboard.grafico_produtor.atual || 0"
                current-value-text="Clientes Positivados: ${value}"
                :width="455"
                needle-color="#000080"
                needle-transition="easeElastic"
                urrent-value-placeholder-style="#{value}"
                style="min-width: 480px;"
              />
            </v-row>
            <template
              v-slot:actions
            >
              <v-icon
                color="info"
                size="16"
                class="ml-1 mr-1"
              >
                mdi-clock-outline
              </v-icon>
              <span
                class="caption grey--text font-weight-light"
              >
                {{ labelGrafico }}
              </span>
            </template>
          </material-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import VueSpeedometer from 'vue-speedometer'
  import { mapGetters, mapState, mapActions } from 'vuex'
  import MaterialCard from '../../components/base/MaterialCard'
  import MaterialChartCard from '../../components/base/MaterialChartCard'
  import { BOOTSTRAP, LOAD_BATCH } from '@/store/modules/dashboard'
  import Tooltips from 'chartist-plugin-tooltips-updated'
  import Legend from 'chartist-plugin-legend'
  import { currencyFormatter } from '../../utils/formatter'

  export default {
    name: 'DashboardGestor',
    components: {
      MaterialChartCard,
      MaterialCard,
      VueSpeedometer,
    },
    data () {
      return {
        // styles: {
        //   width: '500px',
        //   height: '300px',
        //   background: '#2a2744',
        // },
        optionsCatServico: {
          donut: false,
          width: '70%',
          donutWidth: '30%',
          donutSolid: true,
          labelDirection: 'explode',
          showLabel: true,
          height: 290,
          labelOffset: -20,
          plugins: [
            Legend(),
            Tooltips({
              appendToBody: false,
              tooltipFnc: function (meta, value) { return meta + '<br />' + ' R$ ' + currencyFormatter(value) },
            }),
          ],
          labelInterpolationFnc: this.calcCategoria,
        },
        optionsSet: {
          donut: false,
          width: '70%',
          donutWidth: '30%',
          donutSolid: true,
          labelDirection: 'explode',
          showLabel: true,
          labelOffset: -20,
          height: 290,
          plugins: [
            Legend(),
            Tooltips({
              appendToBody: false,
              tooltipFnc: function (meta, value) { return meta + '<br />' + ' R$ ' + currencyFormatter(value) },
            }),
          ],
          labelInterpolationFnc: this.calcSet,
        },
        searchDates: {
          name: 'gestor',
          label: 'f',
          selected: 'Trimestre',
          from: null,
          to: null,
        },
      }
    },
    computed: {
      ...mapState({ user: state => state.user }),
      ...mapState('dashboard', ['ready', 'dashboard']),
      ...mapGetters(['hasPermission']),

      labelGrafico () {
        switch (this.searchDates.label) {
          case 0:
            return 'Últimos ' + (this.moment(this.searchDates.to).diff(this.moment(this.searchDates.from), 'days') + 1) + ' dias'
          case 1:
            return 'Últimos ' + (this.moment(this.searchDates.to).diff(this.moment(this.searchDates.from), 'days') + 1) + ' dias'
          case 2:
            return 'Últimos ' + (this.moment(this.searchDates.to).diff(this.moment(this.searchDates.from), 'days') + 1) + ' dias'
          case 3:
            return 'Últimos ' + (this.moment(this.searchDates.to).diff(this.moment(this.searchDates.from), 'days') + 1) + ' dias'
          case 4:
            return 'Últimos ' + (this.moment(this.searchDates.to).diff(this.moment(this.searchDates.from), 'days') + 1) + ' dias'
          case 6:
            return `Período de ${this.moment(this.searchDates.from).format('DD/MM/YYYY')} a ${this.moment(this.searchDates.to).format('DD/MM/YYYY')}`
          default:
            return ''
        }
      },
    },
    methods: {
      ...mapActions('dashboard', [BOOTSTRAP, LOAD_BATCH]),
      calcCategoria (value, idx) {
        /* eslint-disable no-undef */
        const series = this.dashboard.grafico_atendimento_categoria_servico?.series

        if (!series || !series.length) return '0 %'

        const currentValue = Number(series[idx]?.value) || 0
        const total = series.reduce((sum, item) => {
          const numValue = Number(item.value) || 0
          return sum + numValue
        }, 0)

        if (total === 0) return '0 %'

        const percentage = Math.round((currentValue / total) * 100)
        return percentage + ' %'
        /* eslint-enable no-undef */
      },
      calcTecnico (value, idx) {
        /* eslint-disable no-undef */
        const series = this.dashboard.grafico_atendimento_tecnico?.series || []
        const rawValues = series.map(s => parseFloat(s.value))

        const totalValue = rawValues.reduce((a, b) => a + b, 0)
        if (totalValue === 0) return ''

        const percentages = rawValues.map(v => (v / totalValue) * 100)
        let rounded = percentages.map(p => Math.round(p))
        rounded = rounded.map((r, i) => {
          return rawValues[i] > 0 && r === 0 ? 1 : r
        })

        const somaAtual = rounded.reduce((a, b) => a + b, 0)
        const diff = 100 - somaAtual

        if (diff !== 0) {
          let maiorIndice = null
          let maiorValor = -Infinity

          rawValues.forEach((v, i) => {
            if (v > 0 && v > maiorValor) {
              maiorValor = v
              maiorIndice = i
            }
          })

          if (maiorIndice !== null) {
            rounded[maiorIndice] += diff
          }
        }
        if (rawValues[idx] === 0) return ''

        return rounded[idx] + ' %'
        /* eslint-enable no-undef */
      },
      calcSet (value, idx) {
        /* eslint-disable no-undef */
        const series = this.dashboard.grafico_atendimento_setor?.series || []
        const rawValues = series.map(s => parseFloat(s.value))

        const totalValue = rawValues.reduce((a, b) => a + b, 0)
        if (totalValue === 0) return '0 %'
        const percentages = rawValues.map(v => (v / totalValue) * 100)
        let rounded = percentages.map(p => Math.round(p))
        rounded = rounded.map((r, i) => {
          return rawValues[i] > 0 && r === 0 ? 1 : r
        })
        const somaAtual = rounded.reduce((a, b) => a + b, 0)
        const diff = 100 - somaAtual

        if (diff !== 0) {
          let maiorIndice = null
          let maiorValor = -Infinity

          rawValues.forEach((v, i) => {
            if (v > 0 && v > maiorValor) {
              maiorValor = v
              maiorIndice = i
            }
          })

          if (maiorIndice !== null) {
            rounded[maiorIndice] += diff
          }
        }
        if (rawValues[idx] === 0) return ''

        return rounded[idx] + ' %'
        /* eslint-enable no-undef */
      },
      redirecionamento (path, query) {
        return () => this.$router.push({ path, query })
      },
      cadastros () {
        this.$router.push({ path: 'cadastros/?status=Em análise' }).catch(() => {})
      },
      pontos (options) {
        var defaultOptions = {
          labelClass: 'ct-label',
          labelOffset: {
            x: 0,
            y: -10,
          },
          textAnchor: 'middle',
          align: 'center',
          labelInterpolationFnc: this.$chartist.noop,
        }

        var labelPositionCalculation = {
          point: function (data) {
            return {
              x: data.x,
              y: data.y,
            }
          },
          bar: {
            left: function (data) {
              return {
                x: data.x1,
                y: data.y1,
              }
            },
            top: function (data) {
              return {
                x: data.x1,
                y: data.y2,
              }
            },
            center: function (data) {
              return {
                x: data.x1 + (data.x2 - data.x1) / 2,
                y: data.y2,
              }
            },
            right: function (data) {
              return {
                x: data.x2,
                y: data.y1,
              }
            },
          },
        }

        options = this.$chartist.extend({}, defaultOptions, options)

        function addLabel (position, data) {
          var value = data.value.x !== undefined && data.value.y
            ? (data.value.x + ', ' + data.value.y)
            : data.value.y || data.value.x

          value = value === undefined ? '' : value

          data.group.elem('text', {
            x: position.x + options.labelOffset.x,
            y: position.y + options.labelOffset.y,
            style: 'text-anchor: ' + options.textAnchor,
          }, options.labelClass).text(options.labelInterpolationFnc(value))
        }

        return function ctPointLabels (chart) {
          chart.on('draw', function (data) {
            var positonCalculator = (labelPositionCalculation[data.type] && labelPositionCalculation[data.type][options.align]) || labelPositionCalculation[data.type]
            if (positonCalculator) {
              addLabel(positonCalculator(data), data)
            }
          })
        }
      },
      optionsAtendimentoPorTecnico () {
        return {
          low: 0,
          showArea: false,
          seriesBarDistance: 12,
          axisX: {
            offset: 20,
          },
          axisY: {
            onlyInteger: true,
            offset: 60,
          },
          lineSmooth: this.$chartist.Interpolation.monotoneCubic({
            tension: 0.1,
          }),
          width: '1560px',
          height: 290,
          plugins: [
            // this.$chartist.plugins.legend({ legendNames: this.labelGraficoAtendimentoPeriodo }),
            Tooltips({
              appendToBody: false,
              // tooltipFnc: function (meta, value) { return meta + '<br />' + Math.round(value, 0) },
            }),
            this.pontos({
              textAnchor: 'middle',
              labelInterpolationFnc: function (value) { return value },
              labelClass: 'ct-label-barra',
            }),
          ],
          chartPadding: {
            top: 50,
            right: 0,
            bottom: 0,
            left: 0,
          },
        }
      },
    },
  }
</script>

<style lang="scss">

.graficoLine .ct-square {
  height: 290px;
}

.graficoPieTec .ct-square {
  height: 290px;
}

.graficoPieCat .ct-square {
  height: 290px;
}

.graficoLine .v-card--material-chart .v-card--material__heading {
  max-height: 315px;
}

.graficoPieTec .v-card--material-chart .v-card--material__heading {
  max-height: 315px;
}

.graficoPieCat .v-card--material-chart .v-card--material__heading {
  max-height: 315px;
}

.graficoLine .v-card--material-chart .theme--dark.v-card {
  background-color: white !important
}

.graficoPieTec .v-card--material-chart .theme--dark.v-card {
  background-color: white !important
}

.graficoPieCat .v-card--material-chart .theme--dark.v-card {
  background-color: white !important
}

.graficoPieTec .ct-legend {
  z-index: 10;
  list-style: none;
  text-align: left;

  li {
    position: relative;
    padding-left: 23px;
    margin-right: 10px;
    margin-bottom: 3px;
    cursor: pointer;
    display: block;
  }
}

.graficoPieCat .ct-legend {
  z-index: 10;
  list-style: none;
  text-align: left;

  li {
    position: relative;
    padding-left: 23px;
    margin-right: 10px;
    margin-bottom: 3px;
    cursor: pointer;
    display: block;
  }
}

.grafico-barra .ct-bar {
  stroke-width: 13px !important;
}

.ct-label-barra {
  font-size: 0.6rem !important;
  fill: #273993 !important;
  font-weight: bold !important;
}

</style>
<style lang="sass">

.legendasPedido

 .ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut
  stroke: #2DADED

 .ct-legend .ct-series-0:before
    background-color: #2DADED
    border-color: #2DADED

 .ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut
  stroke: #1C4EFF

 .ct-legend .ct-series-1:before
   background-color: #1C4EFF
   border-color: #1C4EFF

 .ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut
  stroke: #D39942

 .ct-legend .ct-series-2:before
   background-color: #D39942
   border-color: #D39942

 .ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut
  stroke:  #44BC58

 .ct-legend .ct-series-3:before
   background-color:  #44BC58
   border-color:  #44BC58

 .ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut
    stroke:  #F25936

 .ct-legend .ct-series-4:before
    background-color:  #F25936
    border-color:  #F25936

 .ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut
    stroke: #E40E0E

 .ct-legend .ct-series-5:before
    background-color:  #E40E0E
    border-color: #E40E0E

 .ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut
    stroke: #184294

 .ct-legend .ct-series-6:before
    background-color: #184294
    border-color: #184294

 .ct-series-h .ct-point, .ct-series-h .ct-line, .ct-series-h .ct-bar, .ct-series-h .ct-slice-donut
    stroke: #79adb4

 .ct-legend .ct-series-7:before
    background-color: #79adb4
    border-color: #79adb4

 .ct-series-i .ct-point, .ct-series-i .ct-line, .ct-series-i .ct-bar, .ct-series-i .ct-slice-donut
    stroke: #188594

 .ct-legend .ct-series-8:before
    background-color: #188594
    border-color: #188594

 .ct-series-j .ct-point, .ct-series-j .ct-line, .ct-series-j .ct-bar, .ct-series-j .ct-slice-donut
    stroke: #167955

 .ct-legend .ct-series-9:before
    background-color: #167955
    border-color: #167955

.legendasCotacao

  .ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut
    stroke: #184294

  .ct-legend .ct-series-0:before
    background-color: #184294
    border-color: #184294

  .ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut
    stroke: #2DADED

  .ct-legend .ct-series-1:before
    background-color: #2DADED
    border-color: #2DADED

  .ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut
    stroke: #1C4EFF

  .ct-legend .ct-series-2:before
    background-color: #1C4EFF
    border-color: #1C4EFF

  .ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut
    stroke:  #D39942

  .ct-legend .ct-series-3:before
    background-color: #D39942
    border-color:  #D39942

  .ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut
    stroke:  #44BC58

  .ct-legend .ct-series-4:before
    background-color: #44BC58
    border-color:  #44BC58

  .ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut
    stroke: #F25936

  .ct-legend .ct-series-5:before
    background-color:  #F25936
    border-color: #F25936

  .ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut
    stroke: #E40E0E

  .ct-legend .ct-series-6:before
    background-color: #E40E0E
    border-color: #E40E0E

  .ct-series-h .ct-point, .ct-series-h .ct-line, .ct-series-h .ct-bar, .ct-series-h .ct-slice-donut
    stroke: #79adb4

  .ct-legend .ct-series-7:before
    background-color: #79adb4
    border-color: #79adb4

  .ct-series-i .ct-point, .ct-series-i .ct-line, .ct-series-i .ct-bar, .ct-series-i .ct-slice-donut
    stroke: #188594

  .ct-legend .ct-series-8:before
    background-color: #188594
    border-color: #188594

  .ct-series-j .ct-point, .ct-series-j .ct-line, .ct-series-j .ct-bar, .ct-series-j .ct-slice-donut
    stroke: #167955

  .ct-legend .ct-series-9:before
    background-color: #167955
    border-color: #167955

</style>
